import { ApiError, ClinicDetails, ClinicSearchResults } from '@core/models';

export interface State {
  clinicSearchResults: ClinicSearchResults;
  clinicsLoading: boolean;
  clinicsError: ApiError;
  clinicDetails: ClinicDetails;
  clinicDetailsLoading: boolean;
  clinicDetailsError: ApiError;
  searchAddress: string;
}

export const initialState: State = {
  clinicSearchResults: null,
  clinicsLoading: false,
  clinicsError: null,
  clinicDetails: null,
  clinicDetailsLoading: false,
  clinicDetailsError: null,
  searchAddress: '',
};
